export default __webpack_public_path__ + "static/media/background.847963b1.png";